export const ERROR_MESSAGE = {
  notLoggedIn: 'NOT_LOGGED_IN',
  loggedIn: 'LOGGED_IN',
  refreshTokenNotFound: 'REFRESH_TOKEN_NOT_FOUND',
  incorrectUserType: 'INCORRECT_USER_TYPE',
  incorrectCorpPrefix: 'INCORRECT_CORP_PREFIX',
  invalidPermissions: 'INVALID_PERMISSIONS',
};
